import balanceAdjustments from '@/locales/es/accounting/balanceAdjustments.locales';
import payments from '@/locales/es/accounting/payments.locales';

export default {
    ...balanceAdjustments,
    ...payments,
};
